import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import { HrStatusAPI } from "../api";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser, logoutSuccess } from "../../redux/modules/userSlice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function ApprovedCustomizedDialogs({ formApprovedProps }) {
  const [commentOpen, setcommentOpen] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id ? params.id : "";
  const { user } = useSelector(selectUser);
  const { userId, formState, nextURL, approvedComment, setApprovedComment } =
    formApprovedProps;

  const handleClickOpen = () => {
    setcommentOpen(true);
  };
  const handleClose = () => {
    setcommentOpen(false);
  };

  const handleCommentChange = (e) => {
    const { value } = e.target;
    setApprovedComment(value);
  };

  const handleApprovedStatus = () => {
    HrStatusAPI.hrFormStatus(userId, "review done", formState, {
      approvedComment,
      reSubmitComment: "",
    })
      .then((res) => {
        if (res.success) {
          nextURL === "AdminEmployees"
            ? navigate(`/${nextURL}`)
            : navigate(`/${nextURL}/${userId}`, { state: { id: userId } });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setcommentOpen(false);
  };

  return (
    <div>
      <div className="col joineeMobilebtn">
        <button
          type="button"
          className="btn btn-outline-success px-3"
          onClick={handleClickOpen}
        >
          Approved
        </button>
      </div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={commentOpen}
        className="svgofclose"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          className="bg-primary text-white"
          onClose={handleClose}
        >
          Add Comments
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <TextField
            id="outlined-multiline-static"
            label="Write your comments here"
            multiline
            rows={4}
            value={approvedComment}
            onChange={handleCommentChange}
            sx={{ width: "45ch" }}
          />
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            className="btn btn-primary border-2 px-3"
            onClick={handleApprovedStatus}
          >
            Approved
          </button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
